import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

function BlogGenerator() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [postType, setPostType] = useState('product_review');
  const [generatedContent, setGeneratedContent] = useState('');
  const [generatedTitle, setGeneratedTitle] = useState('');
  const [generatedTags, setGeneratedTags] = useState([]);
  const [generatedKeywords, setGeneratedKeywords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [error, setError] = useState('');
  const [siteUrl, setSiteUrl] = useState('https://delanci.com/');

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const data = await apiFetch('/api/products?limit=250');
      setProducts(data.products || []);
    } catch (error) {
      console.error('Fetch products error:', error);
      setError(error.message);
      setProducts([]);
    }
  };

  const handleGenerate = async () => {
    if (!selectedProduct) return;
    
    setLoading(true);
    setError('');
    try {
      const data = await apiFetch('/api/blog/generate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product: selectedProduct, postType, siteUrl: siteUrl.trim() || undefined })
      });
      setGeneratedTitle(data.title);
      setGeneratedContent(data.content);
      setGeneratedTags(data.tags || []);
      setGeneratedKeywords(data.realKeywords || []);
      setError(data.gscWarning ? `GSC 数据暂不可用：${data.gscWarning}` : '');
    } catch (error) {
      console.error('Generate blog error:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePublish = async () => {
    if (!generatedContent || !generatedTitle) return;
    
    setPublishing(true);
    setError('');
    try {
      await apiFetch('/api/blog/publish', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title: generatedTitle,
          content: generatedContent,
          tags: generatedTags
        })
      });
      setGeneratedContent('');
      setGeneratedTitle('');
      setGeneratedTags([]);
    } catch (error) {
      console.error('Publish blog error:', error);
      setError(error.message);
    } finally {
      setPublishing(false);
    }
  };

  return (
    <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: '24px' }}>
        <div style={{ flex: '1 1 360px', minWidth: 0 }}>
          <h2 style={{ fontSize: '18px', margin: '0 0 20px', color: '#1a1a1a' }}>📝 AI博客文章生成器</h2>
          {error && (
            <div style={{ padding: '10px 12px', marginBottom: '15px', backgroundColor: '#fdecea', color: '#c62828', borderRadius: '6px', fontSize: '13px' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '15px', padding: '12px 16px', backgroundColor: '#f0f7ff', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '13px', color: '#1565c0' }}>GSC 站点域名（可选）：</span>
            <input
              type="text"
              value={siteUrl}
              onChange={(e) => setSiteUrl(e.target.value)}
              placeholder="https://你的正式域名.com（留空则纯 AI 生成）"
              style={{
                flex: 1,
                minWidth: '250px',
                padding: '6px 10px',
                border: '1px solid #90caf9',
                borderRadius: '4px',
                fontSize: '13px'
              }}
            />
            <span style={{ fontSize: '12px', color: '#666' }}>将从 Google Search Console 拉取真实关键词融入文章</span>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#333' }}>选择产品</label>
            <select
              value={selectedProduct?.id?.toString() || ''}
              onChange={(e) => setSelectedProduct(products.find(p => String(p.id) === e.target.value))}
              disabled={!products.length}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            >
              <option value="">-- 请选择产品 --</option>
              {products.map(p => (
                <option key={p.id} value={p.id}>{p.title}</option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#333' }}>文章类型</label>
            <select
              value={postType}
              onChange={(e) => setPostType(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            >
              <option value="how_to">📖 使用指南</option>
              <option value="makeup_tutorial">💄 妆容教程</option>
              <option value="product_review">📋 产品评测</option>
              <option value="product_comparison">⚖️ 产品对比</option>
              <option value="buying_guide">🛒 选购指南</option>
              <option value="beauty_knowledge">🔬 美妆知识</option>
              <option value="trend_news">📈 趋势资讯</option>
              <option value="makeup_inspiration">✨ 妆容灵感</option>
              <option value="new_product_news">🎉 新品资讯</option>
              <option value="brand_story">🏷️ 品牌故事</option>
            </select>
          </div>

          <button
            onClick={handleGenerate}
            disabled={!selectedProduct || loading}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '6px',
              backgroundColor: '#0084ff',
              color: '#fff',
              cursor: (!selectedProduct || loading) ? 'not-allowed' : 'pointer',
              fontSize: '14px'
            }}
          >
            {loading ? '📝 生成中...' : '📝 生成博客文章'}
          </button>
        </div>

        <div style={{ flex: '1.2 1 420px', minWidth: 0 }}>
          {generatedContent && (
          <>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#333' }}>文章标题：</label>
            <input
              type="text"
              value={generatedTitle}
              onChange={(e) => setGeneratedTitle(e.target.value)}
              style={{
                width: '100%',
                boxSizing: 'border-box',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#333' }}>文章内容：</label>
            <textarea
              value={generatedContent}
              onChange={(e) => setGeneratedContent(e.target.value)}
              rows={15}
              style={{
                width: '100%',
                boxSizing: 'border-box',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '14px',
                resize: 'vertical'
              }}
            />
          </div>
          
          {generatedKeywords.length > 0 && (
            <div style={{ marginBottom: '15px', padding: '10px 14px', backgroundColor: '#e3f2fd', borderRadius: '6px', fontSize: '12px', color: '#1565c0' }}>
              🔍 文章已融入 {generatedKeywords.length} 个 GSC 真实关键词：
              {generatedKeywords.map(k =>
                `${k.keyword}（${k.impressions}次/${k.clicks}点击/第${k.position ?? '—'}位）`
              ).join('、')}
            </div>
          )}
          <button
            onClick={handlePublish}
            disabled={publishing}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '6px',
              backgroundColor: '#28a745',
              color: '#fff',
              cursor: publishing ? 'not-allowed' : 'pointer',
              fontSize: '14px'
            }}
          >
            {publishing ? '发布中...' : '🚀 发布到博客'}
          </button>
          </>
          )}
        </div>
      </div>
    </div>
  );
}

export default BlogGenerator;
